/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { CircularProgress } from "@mui/material";
import { useRouter } from "next/router";
import { Controller, useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { Button } from "components/button";
import CurrencyInput from "components/currencyInput";
import { CurrencyInputProps } from "components/currencyInput/CurrencyInputProps";
import { CustomInput } from "components/custom-input";
import { TagText } from "components/custom-input/custom-input.styles";
import { SelectInput } from "components/select";
import { useFirstCampaign } from "contexts/campaign-context";
// import { useThisUser } from "contexts/user-context";
import { createCampaign } from "pages/api/api_actions";
import { commissionTypes, payoutFrequencies } from "../signup.utils";
import { campaignStepTwoSchema } from "./input-validations";
import { StepOneCamForm } from "./step-3";

type StepTwoCamForm = {
   commission_type: string;
   commission_percent: number;
   commission_amount: string;
   payout_terms: string;
   amount: number;
};

const Step4 = () => {
   const { dispatch, state } = useFirstCampaign();
   // const [amount, setAmount] = useState();
   const limit = 1000;

   // const [errorMessage, setErrorMessage] = useState("");
   const [className, setClassName] = useState("");
   const [className2, setClassName2] = useState("");
   const [value, setValue] = useState<string | number>(0.0);
   const [value2, setValue2] = useState<string | number>(0.0);

   // const [values, setValues] = useState<CurrencyInputOnChangeValues>();
   const [rawValue, setRawValue] = useState<string | undefined>(" ");
   const [rawValue2, setRawValue2] = useState<string | undefined>(" ");
   // const [errorMessage, setErrorMessage] = useState("");

   const handleOnValueChange: CurrencyInputProps["onValueChange"] = (value, _): void => {
      // setValues(values);
      setRawValue(value === undefined ? "undefined" : value || " ");

      if (!value) {
         setClassName("");
         setValue("");
         return;
      }

      if (Number.isNaN(Number(value))) {
         // setErrorMessage("Please enter a valid number");
         setClassName("is-invalid");
         return;
      }

      if (Number(value) > limit) {
         // setErrorMessage(`Max: ${prefix}${limit}`);
         setClassName("is-invalid");
         setValue(value);
         return;
      }

      setClassName("is-valid");
      setValue(value);
   };

   const handleOnValueChange2: CurrencyInputProps["onValueChange"] = (value, _): void => {
      // setValues(values);
      setRawValue2(value === undefined ? "undefined" : value || " ");

      if (!value) {
         setClassName2("");
         setValue2("");
         return;
      }

      if (Number.isNaN(Number(value))) {
         // setErrorMessage("Please enter a valid number");
         setClassName2("is-invalid");
         return;
      }

      if (Number(value) > limit) {
         // setErrorMessage(`Max: ${prefix}${limit}`);
         setClassName2("is-invalid");
         setValue2(value);
         return;
      }

      setClassName2("is-valid");
      setValue2(value);
   };

   // const { userState } = useThisUser();
   // const [amount, setAmount] = useState();
   const [camTwoData, setcamTwoData] = useState<StepTwoCamForm>();
   const [camOneData, setcamOneData] = useState<StepOneCamForm>();
   const {
      register,
      handleSubmit,
      formState: { errors },
      watch,
      control,
   } = useForm<StepTwoCamForm>({
      resolver: yupResolver(campaignStepTwoSchema),
   });
   const router = useRouter();
   useEffect(() => {
      const ISSERVER = typeof window === "undefined";
      !ISSERVER && setcamTwoData(JSON.parse(localStorage.getItem("cam_two") || "{}"));
      !ISSERVER && setcamOneData(JSON.parse(localStorage.getItem("cam_one") || "{}"));
   }, []);

   const onSubmit = (data: StepTwoCamForm) => {
      console.log("clicked");
      dispatch({ type: "set_loading_true", payload: null });

      // route.push("/app");
      // console.log("fireeed oo")
      const sendData = {
         campaign_name: camOneData?.campaign_name,
         campaign_type: camOneData?.campaign_type,
         url: camOneData?.url,
         enable_recurring: camOneData?.enable_recurring === "saas" ? true : false,
         currency: camOneData?.currency,
         interval: camOneData?.interval,
         trial_period_days: camOneData?.trial_period,
         commission_type: data.commission_type,
         commission_percent: data.commission_percent,
         commission_amount: Number(rawValue2),
         payout_terms: data.payout_terms,
         // amount: Number(rawValue),
      };
      dispatch({ type: "set_loading_true", payload: null });
      createCampaign(localStorage.getItem("token"), sendData)
         .then((response) => {
            if (response.data.success) {
               localStorage.setItem("step", "done");
               router.push(`/app?token=${localStorage.getItem("token")}`);
            } else {
               dispatch({ type: "set_loading_false", payload: null });

               Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong! Please try again!",
               });
            }
         })
         .catch((err) => {
            dispatch({ type: "set_loading_false", payload: null });

            console.log(err);

            err.response && console.log(err.response);
            err.response &&
               Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: `${err.response.data.message}`,
               });
         });
   };

   const [fullLoading, setFullLoading] = useState(true);
   const [prefix, setPrefix] = useState<string | undefined>("$");

   useEffect(() => {
      if (camOneData && camTwoData) {
         setFullLoading(false);
      }
      setPrefix(localStorage.getItem("symbol")?.split("-")[1]);
   }, [camOneData, camTwoData]);

   return fullLoading ? (
      <CircularProgress />
   ) : (
      <div>
         <div className="text-block">
            <div className="base">
               <small>STEP 3 OF 3</small>
               <p>Affiliate commission control</p>
            </div>
            <div className="info">
               <h2>Control how your affiliate get their commmissions</h2>
               <p>Carefully select the options that best suit you!</p>
            </div>
         </div>

         <form onSubmit={handleSubmit(onSubmit)}>
            <Controller
               control={control}
               name="commission_type"
               render={({ field: { onChange } }) => (
                  <>
                     <SelectInput
                        label="Commission type"
                        placeholder="Select Commission Type"
                        onChange={(data: any) => onChange(data?.value)}
                        required={true}
                        error={errors.commission_type?.message}
                        options={commissionTypes}
                     />
                  </>
               )}
            />

            {/* <label>Product Amount</label>
            <CurrencyInput
               {...register("amount")}
               id="validationCustom01"
               name="input-1"
               className={`form-control ${className}`}
               value={value}
               onValueChange={handleOnValueChange}
               placeholder="Please enter a number"
               prefix={prefix}
               allowDecimals={true}
               step={1}
               style={{
                  width: "100%",
                  marginTop: 8,
                  height: 65,
                  background: "transparent",
                  border: "solid 1px #000",
                  borderRadius: 5,
                  paddingLeft: "1em",
               }}
            />
            <TagText>What is the actual amount of the item for this program?</TagText> */}

            <br />
            <br />
            {watch("commission_type") === "fixed" && (
               <>
                  <label>Commission Amount</label>
                  <CurrencyInput
                     {...register("commission_amount")}
                     id="validationCustom01"
                     name="input-1"
                     className={`form-control ${className2}`}
                     value={value2}
                     required={true}
                     onValueChange={handleOnValueChange2}
                     placeholder="Please enter commission amount"
                     prefix={prefix}
                     allowDecimals={true}
                     step={1}
                     style={{
                        width: "100%",
                        marginTop: 8,
                        marginBottom: "1em",
                        height: 65,
                        background: "transparent",
                        border: "solid 1px #000",
                        borderRadius: 5,
                        paddingLeft: "1em",
                     }}
                  />
                  <br />
               </>
            )}
            {/* data */}
            {watch("commission_type") === "percentage" && (
               <CustomInput
                  type="number"
                  min="1"
                  id="commissionPercantage"
                  tag="What is the reward for every conversion on this program?"
                  label="Commission Percentage"
                  error={errors.commission_percent?.message ? "Please fill this field" : ""}
                  notAurl={true}
                  custom={true}
                  customText="%"
                  defaultValue={
                     camTwoData?.commission_percent === 0
                        ? watch("commission_percent")
                        : camTwoData?.commission_percent
                  }
                  {...register("commission_percent")}
               />
            )}
            <Controller
               control={control}
               name="payout_terms"
               render={({ field: { onChange } }) => (
                  <>
                     <SelectInput
                        label="Payout Frequency"
                        placeholder="Select Payout Frequency"
                        onChange={(data: any) => onChange(data?.value)}
                        required={true}
                        error={errors.payout_terms?.message}
                        tag="This is the date your affiliates will be paid."
                        options={payoutFrequencies}
                     />
                  </>
               )}
            />

            <Button
               type="submit"
               variant="primary"
               className="ripple"
               id="completeSignup"
               fullWidth={true}
               isLoading={state.loading}
               style={{ fontSize: 16, fontWeight: 500 }}
            >
               {state.loading ? "loading...." : "CONTINUE"}
            </Button>
         </form>
      </div>
   );
};

export { Step4 };
